import {useProject} from "../../../providers/ClientProjectProvider";
import React, {useState} from "react";
import AnimatedNumber from "animated-number-react";
import {Badge} from "reactstrap";
import {SimpleCircleProgress} from "../../../components/CircleProgress";
import {Collapse, Dropdown} from "antd";
import {Link, useNavigate} from "react-router-dom";
import {ClockCircleOutlined, RightOutlined, StopOutlined} from '@ant-design/icons'
import UserImageCircle from "../../../components/UserImageCircle";
import TeamCandidateProvider, {useTeamCandidate} from "../../../providers/TeamCandidateProvider";
import TeamCandidateProposal from "../../candidate-proposal/TeamCandidateProposal";

const ShortlistedTeamCandidateRow = ({onRequest, isActive, onViewProposal, ...props}) => {

    const {
        team,
        addToCandidates,
        removeFromCandidates,
        assignCandidate,
        unassignCandidate,
        // canMessage,
        isDisabled: isCandidateDisabled,
        // canInterview,
        // matchingDisciplines
    } = useTeamCandidate();
    const {project, isProjectUpdating} = useProject();


    const navigate = useNavigate();

    const isDisabled = isProjectUpdating || props.isDisabled || isCandidateDisabled
    // const imageSrc = useMemo(() => {
    //     if (team?.image_path && String(team?.image_path).includes('default-user')) {
    //         return null;
    //     }
    //     return team?.image_path || TB.defaultUserProfileImagePath()
    // }, [team?.id])

    if (!team.isShortlisted()) {
        return null;
    }

    return (
        <div className="flex flex-col lg:flex-row justify-between py-3 sm:py-0" style={{pointerEvents: 'all'}}>
            <div className="flex-1 flex flex-row items-center gap-4">

                <div className="candidate-user">
                    <div className="flex flex-col items-start justify-start gap-2">

                        <div className="flex flex-row gap-3 items-center">
                            <h6 className="truncate max-w-[240px]">
                                {team.name}
                            </h6>
                            <Link className="btn btn-link btn-link-primary hover:underline w-[70px] whitespace-nowrap"
                                  to={`team-profiles/${team.id}`}>
                                View Profile
                            </Link>
                        </div>
                        <div className="flex flex-row items-center">
                            {TB.map(TB.take(team.positions || [], 4), position => (
                                <div className="ml-[-4px]" key={`tp-${team.id}-${position.id}`}>
                                    <UserImageCircle
                                        user={position}
                                        hideTooltip={true} size={36}
                                        className="img-fluid img-grayscale border border-white"/>
                                </div>
                            ))}
                            {team.positions.length > 4 && (
                                <div className="ml-[-4px]">
                                    <div className="user-image-circle w-9 h-9 bg-blue-100">
                                        <div className="initials text-info">
                                            + {team.positions.length - 4}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {team?.hasMatching() && (
                        <div className="flex flex-row items-center">
                            <SimpleCircleProgress
                                stroke={20}
                                width="18px"
                                className="mr-2"
                                value={team.overallMatchPercent()}/>

                            <AnimatedNumber
                                className="font-semibold text-xs mb-0"
                                value={team.overallMatchPercent()}
                                formatValue={(value) => `${TB.round(value)}% Total Match`}
                                duration={1000}/>
                        </div>
                    )}

                </div>


                {/*<div className="candidate-btns m-auto lg:hidden flex flex-col items-center justify-center gap-4 self-stretch">*/}
                {/*    {!isActive && team.hasProposalForClient() && (*/}
                {/*        <React.Fragment>*/}
                {/*            <button*/}
                {/*                className="btn message-btn"*/}
                {/*                disabled={isDisabled}*/}
                {/*                onClick={() => onViewProposal()}>*/}
                {/*                <i className="far fa-comment-alt"/>*/}
                {/*                {team.unreadMessageCount() > 0 && (*/}
                {/*                    <Badge color="danger" pill>{team.unreadMessageCount()}</Badge>*/}
                {/*                )}*/}
                {/*            </button>*/}

                {/*            <button*/}
                {/*                className="btn interview-btn"*/}
                {/*                disabled={isDisabled}*/}
                {/*                onClick={() => onViewProposal('interviews')}>*/}

                {/*                <i className="far fa-calendar-alt"/>*/}

                {/*                {team.hasInterviewUpdateSinceLastViewed() && (*/}
                {/*                    <Badge color="danger" pill>!</Badge>*/}
                {/*                )}*/}
                {/*            </button>*/}
                {/*        </React.Fragment>*/}
                {/*    )}*/}
                {/*</div>*/}

            </div>
            <div className="candidate-btns flex flex-col mx-auto min-w-[100px] items-center justify-center gap-4 self-stretch">
                {!isActive && team.hasProposalForClient() && (
                    <React.Fragment>
                        <button
                            className="btn message-btn"
                            disabled={isDisabled}
                            onClick={() => onViewProposal()}>
                            <i className="far fa-comment-alt"/>
                            {team.unreadMessageCount() > 0 && (
                                <Badge color="danger" pill>{team.unreadMessageCount()}</Badge>
                            )}
                        </button>

                        <button
                            className="btn interview-btn"
                            disabled={isDisabled}
                            onClick={() => onViewProposal('interviews')}>

                            <i className="far fa-calendar-alt"/>

                            {team.hasInterviewUpdateSinceLastViewed() && (
                                <Badge color="danger" pill>!</Badge>
                            )}
                        </button>
                    </React.Fragment>
                )}
            </div>
            <div className="pt-4 lg:pt-0 flex-1 flex flex-row gap-5 items-center justify-end">
                <div className="candidate-rates">
                    <div className="rate-change-container">
                        <h4>Avg Rate:</h4>
                        <h2 className="text-black no-underline">
                            <span>
                                {team.rangedPlatformRates()}/hr
                            </span>
                        </h2>
                    </div>
                    <div className="selected-rate">
                        <h4>Proposed Cost:</h4>
                        <h2>
                            <span>{team.proposedPlatformCost()}</span>
                        </h2>
                    </div>
                </div>

                {team.isAssigned() ? (
                    <button disabled={isDisabled}
                            className="btn btn-success select-hire-btn pointer-events-none text-sm">
                        Selected For Project
                    </button>
                ) : (
                    team.hasProposalForClient() ? (
                        <button onClick={() => onRequest(() => assignCandidate())} disabled={isDisabled || project.assigned_team_candidate}
                                className="btn btn-primary text-sm select-hire-btn">
                            Accept Proposal
                        </button>
                    ) : (
                        <button disabled={true}
                                className="btn no-click text-sm btn-outline-dark select-hire-btn select-unavailable">
                            {team.statusIsWithdrawn() && "No Longer Interested"}

                            {team.statusIsRejected() && <b>Not Interested</b>}

                            {team.statusIsPending() && "Waiting for Proposal"}
                        </button>
                    )
                )}
                <Dropdown menu={{
                    items: [team.isAssigned() ? {
                        key: 'unassign',
                        label: 'Unselect For Project',
                        disabled: isDisabled
                    } : {
                        key: 'remove',
                        label: 'Remove from shortlist',
                        disabled: isDisabled
                    }, {
                        key: 'profile',
                        label: 'View Profile',
                        disabled: isDisabled
                    }],
                    onClick: async ({item, key, keyPath, domEvent}) => {
                        // await TB.wait(200)
                        switch (key) {
                            case 'unassign':
                                return unassignCandidate();
                            case 'remove':
                                return onRequest(() => removeFromCandidates())
                            case 'profile':
                                return navigate(`team-profiles/${team.id}`)
                        }

                    }
                }} trigger={['click']} placement="bottomRight">
                    <button disabled={isDisabled} className="btn btn-outline-dark min-h-[45px]">
                        <p><i className="fas fa-ellipsis-v"/></p>
                    </button>
                </Dropdown>

            </div>
        </div>
    )
}

const ShortlistedTeamCandidateList = ({candidates, onRequest, isDisabled, ...props}) => {

    const {project} = useProject();

    const [activeRow, setActiveRow] = useState(undefined);
    const [selectedTab, setSelectedTab] = useState('cover-letter');

    return (
        <div className="candidates-list">
            <Collapse accordion ghost activeKey={activeRow}
                      expandIcon={({isActive, panelKey, ...panelProps}) => {
                          const matchedCandidate = TB.find(candidates, ['id', parseInt(panelKey)]);

                          if (!matchedCandidate) return null;

                          if (matchedCandidate.declinedPosition()) {
                              return (
                                  <StopOutlined className="text-slate-700 opacity-[.8]"/>
                              )
                          }
                          if (!matchedCandidate || !matchedCandidate.hasProposalForClient()) {
                              return (
                                  <ClockCircleOutlined className="opacity-[.8] text-slate-400"/>
                              )
                          }


                          return (
                              <RightOutlined className="clickable" onClick={async (e) => {
                                  e.preventDefault()
                                  if (String(activeRow) === String(panelKey)) {
                                      return setActiveRow(undefined)
                                  } else {
                                      if (panelKey && !activeRow && selectedTab !== 'cover-letter') {
                                          await setSelectedTab('cover-letter')
                                      }
                                      return setActiveRow(panelKey)
                                  }
                              }} rotate={isActive ? 90 : undefined}/>
                          )

                      }}
                      onChange={async (key) => {
                          // console.log('onChange', key);
                      }}>
                {TB.map(TB.filter(candidates, ['job_candidate.is_shortlisted', true]), (candidate, i) => (
                    <Collapse.Panel
                        key={candidate.id}
                        collapsible={'header'}
                        style={!candidate.hasProposalForClient() ? (candidate.declinedPosition() ? {background: 'rgba(211,216,220,0.8)'} : (candidate.statusIsPending() ? {background: '#F5F6F8'} : undefined)) : undefined}
                        header={(
                            <TeamCandidateProvider team={candidate}>
                                <ShortlistedTeamCandidateRow
                                    onRequest={onRequest}
                                    isActive={activeRow === candidate.id}
                                    onViewProposal={async (tab) => {
                                        if (tab && tab !== selectedTab) {
                                            await setSelectedTab(tab)
                                        }
                                        setActiveRow(candidate.id)
                                    }}
                                    isDisabled={isDisabled}/>
                            </TeamCandidateProvider>
                        )}>
                        <TeamCandidateProvider team={candidate}>
                            <TeamCandidateProposal
                                isDisabled={isDisabled}
                                project={project}
                                minimal={true}
                                selectedTab={selectedTab}
                                onTabChange={setSelectedTab}
                                team={candidate}
                                canRequestInterview={false}
                                onRequest={onRequest}
                            />
                        </TeamCandidateProvider>
                    </Collapse.Panel>
                ))}
            </Collapse>

        </div>
    )
}

export default ShortlistedTeamCandidateList